module.exports = __webpack_public_path__ + "img/hazmat-check-active.c914923d.svg";